"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePolicyTerms = void 0;
var next_api_swr_1 = require("@newfront-insurance/next-api-swr");
var react_1 = require("react");
var provider_1 = require("../provider");
var routes_1 = require("../routes");
/**
 * Load all of the policy terms
 */
function usePolicyTerms(config) {
    var basePath = (0, react_1.useContext)(provider_1.NewfrontApiContext).basePath;
    return (0, next_api_swr_1.useNextApiSubscription)(routes_1.apiRoutes.getPolicyTerms(basePath), config);
}
exports.usePolicyTerms = usePolicyTerms;
